import TruncatedText from "components/modules/CRM/TruncatedTextPopover"


export type Stat = {
  label: string
  value: string | number
  accent?: 'success' | 'warning' | 'emphasis'
}


function StatCard({ label, value, accent }: Stat) {
  const accentClass =
    accent === 'success' ? 'text-green-400' : accent === 'warning' ? 'text-amber-400' : accent === 'emphasis'
      ? 'text-emphasis' : 'text-neutral'

  return (
    <div className="flex-1 rounded-xl bg-primary-variant px-4 py-2">
      <TruncatedText
        text={String(value)}
        className={`text-lg font-semibold ${accentClass}`}
        maxWidth={280}
      />
      <div className="mt-0.5 text-[13px] text-neutral-faded">{label}</div>
    </div>
  )
}

export default StatCard;